import { formatDate } from '@angular/common';
import { DATE_TIME_FORMAT } from '@models/common.models';

export function getDateWithoutTimeOrTimezone(value: Date | string): Date | null {
  if (typeof value === 'string') {
    const dateOnlyMatch = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
    if (dateOnlyMatch) {
      const [, year, month, day] = dateOnlyMatch;
      return new Date(Number(year), Number(month) - 1, Number(day));
    }
  }

  const date = value instanceof Date ? value : new Date(value);
  return isNaN(date.getTime()) ? null : new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

export function convertDateTimeToDateOnlyString(date: Date): string {
  // get rid of time part by creating new date that will not have TZ info
  const utcDateOnly = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));

  // return date only string in YYYY-MM-DD format
  return utcDateOnly.toISOString().split('T')[0];
}

export function formatShortDate(value: string | null | undefined): string {
  if (!value) {
    return '';
  }

  const date = new Date(value);
  if (isNaN(date.getTime())) {
    return value;
  }

  return formatDate(date, DATE_TIME_FORMAT.DATE_FILTER_FORMAT, 'en-US');
}

export function formatDateRange(rangeStart: string | null | undefined, rangeEnd: string | null | undefined): string {
  const start = formatShortDate(rangeStart);
  const end = formatShortDate(rangeEnd);

  if (start && end) {
    return `${start} - ${end}`;
  }

  return start || end;
}
